import type { FormErrorSeverity, TranslatedValidationError } from 'models/formError';

const serverityToColorMapping: Record<FormErrorSeverity, ValidationColor> = {
  Error: 'warning',
  Failure: 'danger',
  Warning: 'info',
};
export type ValidationColor = 'info' | 'warning' | 'danger';

export const toColor = (validationError: TranslatedValidationError): ValidationColor =>
  serverityToColorMapping[validationError.severity];
